import * as React from "react";
import AreaTitle from "../AreaTitle/index";
import { Route } from "react-router-dom";
import InternalRedirect from "../Navigation/InternalRedirect/InternalRedirect";
import routeLinks from "../../routeLinks";
import { EmptyPage, ImageHeight } from "../EmptyPage/EmptyPage";
import { SomethingsWrong } from "components/Images/Images/NotFound/SomethingsWrong";

const RedirectAs404 = () => <Route render={({ location }) => <InternalRedirect to={{ ...location, state: { is404: true } }} />} />;

const NotFound = () => (
    <main id="maincontent">
        <AreaTitle link={routeLinks.root} title="Page not found" />
        <EmptyPage title="Sorry, the page you are looking for could not be found" image={<SomethingsWrong height={ImageHeight} />} />
    </main>
);

export { NotFound, RedirectAs404 };
